<header class="rcp__head">
  <h2 class="bk-eyebrow" id="compose-recipients-title">Recipients</h2>
  <p class="rcp__lead">
    Add numbers, upload a file, or choose saved contacts and groups. Anyone who appears more than once gets
    the message once.
  </p>
</header>

@if (missing) {
  <p class="bk-field__error rcp__missing" role="alert">
    <span class="bk-sym" aria-hidden="true">error</span>
    Add at least one recipient before you review the message.
  </p>
}

<!-- A single number -->
<form class="rcp__number" [formGroup]="phoneNumberForm" (ngSubmit)="addPhoneNumber()">
  <input-field
    class="rcp__tel"
    label="Phone number"
    [errorMessage]="
      phoneNumberSubmitted && phoneNumberForm.controls.phoneNumber.invalid
        ? 'Enter a full phone number. Pick the country first if it is not shown.'
        : ''
    "
    [hint]="
      phoneNumberCount
        ? formatCount(phoneNumberCount) + (phoneNumberCount === 1 ? ' number added' : ' numbers added')
        : 'Press Enter or choose Add number after each one.'
    "
  >
    <ngx-mat-input-tel
      formControlName="phoneNumber"
      [enablePlaceholder]="true"
      [preferredCountries]="['bw', 'za']"
      [enableSearch]="true"
    />
  </input-field>

  <button type="submit" class="bk-btn bk-btn--ghost rcp__add">
    <span class="bk-sym" aria-hidden="true">add</span>
    Add number
  </button>
</form>

<!-- Everything else opens a picker -->
<div class="rcp__sources" role="group" aria-label="More ways to add recipients">
  <button type="button" class="rcp__source" (click)="openCSVPhoneNumbersModalEvent.emit()">
    <span class="bk-sym rcp__icon" aria-hidden="true">upload_file</span>
    <span class="rcp__text">
      <span class="rcp__name">Upload a file</span>
      <span class="rcp__meta">
        {{ csvFileCount ? formatCount(csvFileCount) + (csvFileCount === 1 ? " file added" : " files added") : "CSV or Excel with a phone column" }}
      </span>
    </span>
    <span class="bk-sym rcp__go" aria-hidden="true">chevron_right</span>
  </button>

  <button type="button" class="rcp__source" data-source="contacts" (click)="openSelectContactsModalEvent.emit()">
    <span class="bk-sym rcp__icon" aria-hidden="true">person</span>
    <span class="rcp__text">
      <span class="rcp__name">Contacts</span>
      <span class="rcp__meta" [class.is-set]="contactsCount">{{ chosen(contactsCount, "Pick people one by one") }}</span>
    </span>
    <span class="bk-sym rcp__go" aria-hidden="true">chevron_right</span>
  </button>

  <button type="button" class="rcp__source" data-source="tags" (click)="openSelectTagsModalEvent.emit()">
    <span class="bk-sym rcp__icon" aria-hidden="true">sell</span>
    <span class="rcp__text">
      <span class="rcp__name">Tags</span>
      <span class="rcp__meta" [class.is-set]="tagsCount">{{ chosen(tagsCount, "Everyone with a tag") }}</span>
    </span>
    <span class="bk-sym rcp__go" aria-hidden="true">chevron_right</span>
  </button>

  <button type="button" class="rcp__source" data-source="organizations" (click)="openSelectOrganizationsModalEvent.emit()">
    <span class="bk-sym rcp__icon" aria-hidden="true">domain</span>
    <span class="rcp__text">
      <span class="rcp__name">Organizations</span>
      <span class="rcp__meta" [class.is-set]="organizationsCount">{{ chosen(organizationsCount, "Everyone in an organization") }}</span>
    </span>
    <span class="bk-sym rcp__go" aria-hidden="true">chevron_right</span>
  </button>

  <button type="button" class="rcp__source" data-source="segments" (click)="openSelectSegmentModalEvent.emit()">
    <span class="bk-sym rcp__icon" aria-hidden="true">filter_alt</span>
    <span class="rcp__text">
      <span class="rcp__name">Segments</span>
      <span class="rcp__meta" [class.is-set]="segmentsCount">{{ chosen(segmentsCount, "Everyone matching saved filters") }}</span>
    </span>
    <span class="bk-sym rcp__go" aria-hidden="true">chevron_right</span>
  </button>
</div>
